import AES from 'crypto-js/aes';
export const EncryptionKey = 'its lcd project rkl';

export default function EncryptData(msg: string | object) {
    console.log("Encrypting Data >>", msg)
    if (typeof msg === 'object')
        return AES.encrypt(JSON.stringify(msg), EncryptionKey).toString();
    return AES.encrypt(msg, EncryptionKey).toString();
}
